(function () {
    'use strict';

    angular
        .module('cacmEventRoutes', [
            'cacmEventEditModule',
            'searchV2Module',
        ])
        .config(router);

    router.$inject = ['$stateProvider', 'historyCtxtServiceProvider'];

    function router($stateProvider, historyCtxtServiceProvider) {
        $stateProvider

            .state('cacmEditEvent', {
                url: '/CACM/Event/{CACMEventID:int}',
                params: historyCtxtServiceProvider.getStateParamsConfig(),
                resolve: {
                    cacmEvent: ['$stateParams', 'cacmService', function ($stateParams, service) {
                        return service.getCacmEvent($stateParams.CACMEventID);
                    }]
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent"></div>',
                    },
                    'mainContent@cacmEditEvent': {
                        templateUrl: require('./cacmEventEdit.tpl.html'),
                        controller: 'CacmEventEditController'
                    }
                }
            })

        .state('cacmLinkedControlTest', {
            url: '/Control/{ControlID}/Test/{ControlTestID}',
            sendToGovNew: true
        });
    }
})();
